<template>
  <div id="profile" class="container">
    <section>
      <div class="section-group">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body box-profile" v-if="customers">
                <div class="text-center">
                  <!-- <img
                    class="profile-user-img img-fluid img-circle"
                    :src="customer.userLogoBig"
                    alt="User profile picture"
                  /> -->
                  <!-- <el-avatar
                    :src="customer.userLogoBig"
                    :size="100"
                  ></el-avatar> -->
                  <avatarVue
                    :src="`${customers.userLogoBig}?v=${getN()}`"
                    :size="100"
                  ></avatarVue>
                </div>
                <h3 class="profile-username text-center mb-1">
                  {{ customers.displayName }}
                </h3>
                		  <div class="reward_center mt-2 mb-2">
                      <!-- 獎牌名單列表 -->
      				<div class="toooltip" v-for="(item, idx) in medalListData" :key="idx">
      					<img :src="item.sgL_URL" style="width:40px;">
      					<span class="toooltiptext">{{ item.sgL_Title }}<br/> 
      						<span class="exchange_point b-operate-btn" type="button" @click="showExchangePoint(item.id)">兌換為點數</span>
      					</span>
      				</div>
      			  </div>
              <p class="text-center mb-1">現有點數：{{ Runningwater.sgL_AfterPoint ? Runningwater.sgL_AfterPoint : 0 }}</p>
                <p class="text-muted text-center">{{ customers.sgL_Myself }}</p>
              </div>
              <!-- /.card-body -->
              <div class="card-body">
                <ul>
                <li class="profile-nav" v-if="customers">
                              <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': customers.userId } }">
                            <i class="fas fa-user-circle fa-fw mr-1" /> {{ $t('Customer.customerPublish.Homepage') }}
                              </router-link>
                            </li>
                  <li class="profile-nav active">
                    <!-- <router-link :to="{ name: 'customerPublish' }">
                      <i class="fas fa-share fa-fw mr-1"></i> 發佈內容
                    </router-link> -->
                   
                    <a href="javascript:" @click="pushContent">
                      <i class="fas fa-share fa-fw mr-1"></i>  {{ $t('Customer.customerPublish.customerPublish') }}
                    </a>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerFavorite' }"
                      ><i class="fas fa-bookmark fa-fw mr-1"></i>  {{ $t('Customer.customerPublish.customerFavorite') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPrivateMessage' }"
                      ><i class="fas fa-comments fa-fw mr-1"></i>  {{ $t('Customer.customerPublish.customerPrivateMessage') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerInfo' }"
                      ><i class="fas fa-cog fa-fw mr-1"></i>  {{ $t('Customer.customerPublish.customerInfo') }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-9 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <ul class="nav nav-pills" v-if="countList != null">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType === 1 }"
                          href="javascript:void(0);"
                          @click="showContent(1)"
                          data-toggle="tab"
                          > {{ $t('Customer.customerPublish.Photoalbum') }}<span class="count">{{
                            this.countList.photoCount
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType === 2 }"
                          href="javascript:void(0);"
                          @click="showContent(2)"
                          data-toggle="tab"
                          > {{ $t('Customer.customerPublish.videofeed') }}<span class="count">{{
                            this.myPhotoDtl.videoCount
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType === 3 }"
                          href="javascript:void(0);"
                          @click="showContent(3)"
                          data-toggle="tab"
                          > {{ $t('Customer.customerPublish.motionpicture') }}<span class="count">{{
                            this.myPhotoDtl.photoCount
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType === 4 }"
                          href="javascript:void(0);"
                          @click="showContent(4)"
                          data-toggle="tab"
                          > {{ $t('Customer.customerPublish.blog') }}<span class="count">{{
                            this.blogCount
                          }}</span></a
                        >
                      </li>

                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType === 5 }"
                          href="javascript:void(0);"
                          @click="showContent(5)"
                          data-toggle="tab"
                          > {{ $t('Customer.customerPublish.message') }}
                          <!-- <span class="count">{{this.blogCount}}</span> -->
                          </a>
                      </li>

                    </ul>
                  </div>
                  <!-- Search bar -->
                  <div class="col-4">
                    <div class="search">
                      <el-input
                        :placeholder="$t('Customer.customerPublish.search')"
                        suffix-icon="fas fa-search"
                        v-model="title"
                      ></el-input>
                    </div>
                  </div>
                  <!-- /.Search bar -->
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body" v-show="showType === 1">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getalbumList">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerPublish.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublish.Noalbum') }}</div>
                  </div>
                </div>
                <div class="my-profile section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-6 col-md-4 col-lg-3"
                          v-for="album in albumList"
                          :key="album.id"
                        >
                          <div class="album-card card">
                            <div
                              :class="{
                                notclick: 9999 == album.sgL_DevicesType,
                              }"
                            >
                              <router-link
                                :title="
                                  album.sgL_DevicesType === 9999
                                    ? `${$t('Customer.customerPublish.processed')} ${album.lodingThisPhoto} ${$t('Customer.customerPublish.piece')}`
                                    : ''
                                "
                                :to="{
                                  name: 'albumviewPhotostream',
                                  query: { id: album.id },
                                }"
                              >
                                <div class="album-block">
                                  <div class="album-thumbnail">
                                    <div class="album-responsive">
                                      <div class="album-sizer">
                                        <div
                                          v-if="album.sgL_DevicesType != 9999"
                                          class="album-image"
                                          :style="{
                                            backgroundImage:
                                              'url(' +
                                              `${album.photoImage}` +
                                              ')',
                                          }"
                                        ></div>
                                        <div
                                          v-else
                                          class="album-image"
                                          :style="{
                                            backgroundImage:
                                              'url(' +
                                              require('../../assets/images/loading.gif') +
                                              ')',
                                          }"
                                        ></div>
                                      </div>
                                    </div>
                                    <div class="detailTool">
                                      <div
                                        class="album-photo-count-loading"
                                        v-if="album.sgL_DevicesType === 9999"
                                      >
                                        <img
                                          src="../../assets/images/loading_24px.gif"
                                          width="15px"
                                          height="15px"
                                        />
                                        {{ album.lodingThisPhoto }}
                                      </div>
                                      <div
                                        class="album-photo-count"
                                        style="position: initial; height: 20px"
                                      >
                                        <span>{{
                                          album.sgL_PG_CPhotoQuantityF
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="actions" style="bottom: 0px">
                                    <a
                                      class="bookmark"
                                      :title="$t('Customer.customerPublish.bookmark')"
                                      href="javascript:void(0)"
                                      @click="
                                        addfavorite(
                                          album.id,
                                          album.sgL_PG_CMasterSort,
                                          0,
                                          null
                                        )
                                      "
                                      ><i
                                        class="fas fa-bookmark fa-fw"
                                        v-if="album.isCollection"
                                      ></i
                                      ><i
                                        class="far fa-bookmark fa-fw"
                                        v-else
                                      ></i
                                    ></a>
                                    <a class="share" :title="$t('Customer.customerPublish.share')"
                                      ><i class="fa fa-share fa-fw"></i
                                    ></a>
                                    <router-link
                                      :to="{
                                        name: 'uploadImage',
                                        query: { id: album.id, tid: 3 },
                                      }"
                                      ><i class="fas fa-pen fa-fw"></i
                                    ></router-link>
                                    <a
                                      class="delete"
                                      href="javascript:void(0)"
                                      @click.stop="open(album.id, 'Album')"
                                      title="$t('Customer.customerPublish.del')"
                                      ><i class="fas fa-trash-alt fa-fw"></i
                                    ></a>
                                  </div>
                                </div>
                                <div
                                  class="album-info"
                                  style="padding: 10px 1rem 0px 1rem"
                                >
                                  <div
                                    class="album-title mb-2"
                                    style="height: 1rem"
                                    :title="album.sgL_PG_CName"
                                  >
                                    {{ album.sgL_PG_CName }}
                                  </div>
                                </div>
                              </router-link>
                              <div class="album-info" style="padding: 5px 1rem">
                                <div
                                  style="word-break: break-all; color: black"
                                >
                                  {{ getSortLink(album.id) }}
                                </div>
                                <span class="album-upload-date">{{
                                  album.sgL_PG_CAddTimerI
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5">
                    <div class="col-12">
                      <!--  引用分页组件 -->
                      <pagination
                        v-if="getPageShow"
                        :currentPage="pageParams.currentPage"
                        :total="pageParams.total"
                        :limit="pageParams.limit"
                        :small="true"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                      />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="showType === 2">
                <!-- My Profile -->
                <div
                  class="profile-album section-group"
                  v-if="!videoList || videoList.length === 0"
                >
                  <div class="empty-block">
                      <div class="empty-block-inner" v-if="dataList == true">
                         {{ $t('Customer.customerPublish.loading') }}...
                      </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublish.Noaudio') }}</div>
                  </div>
                </div>
                <div class="my-profile section-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <singleVideoVue
                          class="pool-cloud fm-set col-sm-12 col-md-6 col-lg-4"
                          style="padding: 5px"
                          v-for="item in videoList"
                          :id="item.id"
                          :url="item.fileShareUrl"
                          :key="item.id"
                          :avatar="item.userLogoBig"
                          :authorName="item.sgL_MyVideoName"
                          :displayName="item.sgL_UsersName"
                          :date="item.sgL_PG_CAddTimerI"
                          :lookCount="item.sgL_PG_CTotalView"
                          :title="item.sgL_Title"
                          :likeCount="item.sgL_PG_CTotalLike"
                          :poster="item.sgL_ImageTempURL"
                          :poster2="item.jietuFileUrl"
                          :item="item"
                          :IsShow="item.sgL_IsShow"
                          @viewData="showPic(item)"
                          @like="likeFunc(item, item.sgL_IsLike)"
                        >
                          <template v-slot:SpecifyMenu>
                            <moreMenuVue @ck="copyLink(item.id)">
                              <template v-slot:icon>
                                <i class="fa fa-clone mr-1"></i>
                              </template>
                              <template v-slot:txt>  {{ $t('Customer.customerPublish.link') }} </template>
                            </moreMenuVue>
                            <moreMenuVue
                              @ck="changeShow(item)"
                              v-if="!item.sgL_IsShow"
                            >
                              <template v-slot:icon>
                                <i class="fa fa-rss mr-1"></i>
                              </template>
                              <template v-slot:txt>  {{ $t('Customer.customerPublish.publicity') }} </template>
                            </moreMenuVue>
                            <moreMenuVue @ck="changeShow(item)" v-else>
                              <template v-slot:icon>
                                <i class="fa fa-eye-slash mr-1"></i>
                              </template>
                              <template v-slot:txt>  {{ $t('Customer.customerPublish.Notpublic') }} </template>
                            </moreMenuVue>
                            <moreMenuVue
                              @ck="
                                deleteFunc({
                                  id: item.id,
                                })
                              "
                            >
                              <template v-slot:icon>
                                <i class="fa fa-trash mr-1"></i>
                              </template>
                              <template v-slot:txt>  {{ $t('Customer.customerPublish.del') }} </template>
                            </moreMenuVue>
                          </template>
                        </singleVideoVue>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row my-5"
                    v-if="videoList && videoList.length > 0"
                  >
                    <div class="col-12">
                      <!--  引用分页组件 -->
                      <pagination
                        v-if="getPageShowvideo"
                        :currentPage="pageParamsVideo.currentPage"
                        :total="pageParamsVideo.total"
                        :limit="pageParamsVideo.limit"
                        :small="true"
                        @handleCurrentChange="handleCurrentChangevideo"
                        @handleSizeChange="handleSizeChangevideo"
                      />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="showType === 3">
                <div class="my-profile section-group">
                  <div class="empty-block" v-if="!picList || picList.length === 0">
                    <div class="empty-block-inner" v-if="dataList == true"> {{ $t('Customer.customerPublish.loading') }}...</div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublish.Nophotograph') }}</div>
                </div>
                  
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-6 col-md-4 col-lg-3"
                          v-for="item in picList"
                          :key="item.id"
                        >
                          <a href="javascript:void(0);" @click="showPic(item)">
                            <div class="feedpost-photo-card card">
                              <div class="feedpost-block">
                                <div class="feedpost-thumbnail">
                                  <div class="feedpost-responsive">
                                    <div class="feedpost-sizer">
                                      <div
                                        class="feedpost-image"
                                        :style="{
                                          backgroundImage:
                                             'url(' + `${!item.sgL_GroupId ? item.sgL_ImageTempURL :
                                             item.sgL_GroupImageTemplS ? item.sgL_GroupImageTemplS[0] : ''}` + ')',
                                        }"
                                      >
                                       <div class="detailTool" v-if="item.sgL_GroupId">
                                      <div
                                        class="album-photo-count"
                                        style="position: initial; height: 20px"
                                      >
                                        <span>
                                          {{ item.sgL_GroupImageTemplS ? item.sgL_GroupImageTemplS.length : 0 }}
                                        </span>
                                      </div>
                                       </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5" v-if="picList && picList.length > 0">
                    <div class="col-12">
                      <!--  引用分页组件 -->
                      <pagination
                        :currentPage="pageParamsPic.currentPage"
                        :total="pageParamsPic.total"
                        :limit="pageParamsPic.limit"
                        :small="true"
                        @handleCurrentChange="handleCurrentChangepic"
                        @handleSizeChange="handleSizeChangepic"
                      />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="showType === 4">
                <div
                  class="my-profile section-group"
                  v-if="blogIndex.blogPage === 0"
                >
                  <div class="row">
                    <div class="col-12">
                      <div>
                        <button
                          type="button"
                          class="btn btn-block btn-primary blogwidth"
                          @click="pushBlog"
                        >
                           {{ $t('Customer.customerPublish.customerPublish') }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-block btn-primary blogwidth"
                          @click="blogIndex.blogPage = 2"
                        >
                           {{ $t('Customer.customerPublish.blogprofile') }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-block btn-primary blogwidth"
                          @click="lookBlogUser()"
                        >
                           {{ $t('Customer.customerPublish.Subscriberdata') }}
                        </button>
                      </div>
                      <!-- 帖文數據 -->
                      <div class="row pt-4 pb-4">
                        <section class="col-12">
                          <!-- 最近上傳項目 -->
                          <div class="card blog_count_height">
                            <div class="card-header">
                              <h3 class="card-title">
                                <i class="fas fa-eye"></i>  {{ $t('Customer.customerPublish.Postviews') }}
                              </h3>
                            </div>
                            <div
                              class="card-body table-responsive p-0 th-height"
                            >
                              <table
                                class="
                                  b-upload-task
                                  table table-striped table-valign-middle
                                  overscroll
                                "
                              >
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th> {{ $t('Customer.customerPublish.title') }}</th>
                                    <th> {{ $t('Customer.customerPublish.Totalpageviews') }}</th>
                                    <th> {{ $t('Customer.customerPublish.Subscribe_browse') }}</th>
                                    <th> {{ $t('Customer.customerPublish.Addsubscription') }}</th>
                                    <th> {{ $t('Customer.customerPublish.praise') }}</th>
                                    <th> {{ $t('Customer.customerPublish.releasedate') }}</th>
                                  </tr>
                                </thead>
                                <tbody
                                  v-for="(item, ix) in blogIndex.blogDataList"
                                  :key="ix"
                                >
                                  <tr>
                                    <td rowspan="1">{{ ix + 1 }}</td>
                                    <td>{{ item.sgL_Title }}</td>
                                    <td>{{ item.sgL_ViewCount }}</td>
                                    <td>{{ item.sgL_SubscribeCount }}</td>
                                    <td>{{ item.sgL_AddSubscribeCount }}</td>
                                    <td>{{ item.sgL_LikeCount }}</td>
                                    <td>{{ item.sgL_CreateTimeF }}</td>
                                  </tr>
                                  <tr>
                                    <td colspan="7">
                                      <span class="progress">
                                        <span
                                          class="progress-bar bg-green"
                                          style="width: 4298"
                                        >
                                          {{ item.sgL_ViewCount }}
                                        </span>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </section>
                      </div>
                      <div
                        class="list_padding p-0 pt-1 pb-1"
                        v-for="(item, ix) in blogIndex.blogDataList"
                        :key="ix"
                        @click="
                          $router.push({
                            name: 'blogDetail',
                            query: {
                              id: item.id,
                            },
                          })
                        "
                      >
                        <div class="list_post blog_chat_fm">
                          <span class="images"
                            ><img :src="item.sgL_UploadTempUrl"
                          /></span>
                          <div class="list_info">
                            <!-- function icon -->
                            <div
                              class="function_icon"
                              style="float: right; padding-right: 20px"
                            >
                              <div class="group_feedpost-more">
                                <i class="fa fa-ellipsis-h"></i>
                                <div
                                  class="group_reply-menus"
                                  style="right: 25px"
                                >
                                  <a
                                    href="javascript:"
                                    @click.stop="lookBlogUser(item.id)"
                                    data-toggle="modal"
                                    data-target="#groupfriendlist"
                                    ><li class="follower">
                                      <i class="fas fa-bell"></i>  {{ $t('Customer.customerPublish.subscriber') }}
                                    </li>
                                  </a>
                                  <a
                                    href="javascript:"
                                    v-if="item.sgL_IsShow"
                                    @click.stop="hideBlog(item.id)"
                                  >
                                    <li class="hidpost">
                                      <i class="fas fa-eye"></i>  {{ $t('Customer.customerPublish.Hide_post') }}
                                    </li>
                                  </a>
                                  <a
                                    href="javascript:"
                                    v-else
                                    @click.stop="hideBlog(item.id)"
                                  >
                                    <li class="hidpost">
                                      <i class="fas fa-eye"></i>  {{ $t('Customer.customerPublish.Display_post') }}
                                    </li>
                                  </a>
                                  <a
                                    href="javascript:"
                                    @click.stop="editBlog(item.id)"
                                    data-toggle="modal"
                                    data-target=".edit_post_text"
                                  >
                                    <li class="mondify">
                                      <i class="fas fa-edit"></i>  {{ $t('Customer.customerPublish.Edit_post') }}
                                    </li>
                                  </a>
                                  <a
                                    href="javascript:"
                                    @click.stop="deleteBlog(item.id)"
                                  >
                                    <li class="delete">
                                      <i class="far fa-trash-alt"></i>  {{ $t('Customer.customerPublish.del_post') }}
                                    </li>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <!-- /.END function icon -->
                            <p class="topimg_icon f-bold d-inline">
                              <img :src="item.sgL_UsersBLog" /><span
                                class="txt"
                                >{{ item.sgL_BlogName }}</span
                              >
                            </p>
                            <p class="blog_count pb-2">
                              <span class="view"
                                ><i class="fas fa-eye">{{
                                  item.sgL_ViewCount
                                }}</i></span
                              >
                              <span class="like"
                                ><i class="fas fa-thumbs-up">{{
                                  item.sgL_LikeCount
                                }}</i></span
                              >
                              <span class="share"
                                ><i class="fas fa-share">{{
                                  item.sgL_SharCount
                                }}</i></span
                              >
                            </p>
                            <p class="list_title">
                              {{ item.sgL_Title }}
                            </p>
                            <span class="desciption fixheight">
                              {{
                                item.sgL_Content
                                  .replace(/<\/?.+?>/g, "")
                                  .replace(/ /g, "")
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <pagination
                          :currentPage="blogIndex.pageParams.currentPage"
                          :total="blogIndex.pageParams.total"
                          :limit="blogIndex.pageParams.limit"
                          :small="true"
                          @handleCurrentChange="handleCurrentChangeBlog"
                          @handleSizeChange="handleSizeChangeBlog"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="blogIndex.blogPage === 1">
                  <ImgCropperVue
                    ref="cro2"
                    @cropperConfirm="cropperConfirm2"
                    :props_autoCropWidth="1280"
                    :props_autoCropHeight="720"
                    :props_full="false"
                    :props_original="true"
                    :props_centerBox="true"
                    :props_high="false"
                    :props_fixed="true"
                    :props_info="true"
                    :props_canMove="true"
                    :props_canScale="true"
                  >
                  </ImgCropperVue>
                  <div class="col-12">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="b-article-image"
                              >* {{ $t('Customer.customerPublish.suggestedsize') }}: 1280*720）</label
                            >
                            <el-upload
                              :auto-upload="false"
                              action=""
                              :show-file-list="false"
                              :on-change="changeUpload2"
                              ref="blogUploader"
                            >
                              <button
                                type="button"
                                class="
                                  btn btn-block btn-primary
                                  blogwidth
                                  display-block
                                "
                              >
                                 {{ $t('Customer.customerPublish.uploadpictures') }}
                              </button>
                            </el-upload>
                            <div
                              v-if="blogInfo.sgL_UploadTempUrl"
                              style="width: 100%; height: 100px"
                            >
                              <img
                                :src="blogInfo.sgL_UploadTempUrl"
                                style="width: 100%; height: 100%"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label for="b-article-title">* {{ $t('Customer.customerPublish.Blog_post_title') }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-2 col-md-3">
                          <div class="form-group">
                            <select
                              class="
                                form-control
                                custom-select
                                select2-no-search
                              "
                              v-model="blogInfo.sgL_NewTypeId"
                            >
                              <option
                                v-for="(item, ix) in blogTypeList"
                                :key="ix"
                                :value="item.id"
                              >
                                {{ item.sgL_NewName }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-10 col-md-9">
                          <div class="form-group">
                            <el-input
                              v-model="blogInfo.sgL_Title"
                              placeholder=""
                              maxlength="35"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <!-- Text Area -->
                          <label for="b-content">* {{ $t('Customer.customerPublish.Article_content') }}</label>
                          <div class="form-group">
                            <Editor
                              v-model="blogInfo.sgL_Content"
                              imageType="blog"
                              :externalServerUrl="true"
                            />
                          </div>
                          <!-- /.text-area -->
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="b-article-source"> {{ $t('Customer.customerPublish.Reprint_source') }}</label>
                            <el-select
                              v-model="blogInfo.sgL_ReprintedId"
                              filterable
                              allow-create
                              default-first-option
                              placeholder=""
                              @change="reprinteChange"
                            >
                              <el-option
                                v-for="item in ReprintedSourceList"
                                :key="item.id"
                                :label="item.sgL_Title"
                                :value="`${item.id}&&&&${item.sgL_Title}`"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="b-keywords"
                              > {{ $t('Customer.customerPublish.Keywords') }}</label
                            >
                            <input
                              type="text"
                              id="b-keywords"
                              class="form-control"
                              :placeholder="$t('Customer.customerPublish.Chartered')"
                              v-model="blogInfo.sgL_KeyWord"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="b-visibility"> {{ $t('Customer.customerPublish.Open_state') }}</label>
                            <select
                              v-model="blogInfo.sgL_IsShow"
                              class="
                                form-control
                                custom-select
                                select2-no-search
                              "
                            >
                              <option :value="true"> {{ $t('Customer.customerPublish.reveal') }}</option>
                              <option :value="false"> {{ $t('Customer.customerPublish.Hidden') }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row justify-content-center">
                      <div class="col-8">
                        <a
                          href="javascript:"
                          @click="
                            blogIndex.blogPage = 0;
                            resetBlogInfo();
                            GetAllMyLogin();
                          "
                          class="btn btn-secondary"
                          > {{ $t('Customer.customerPublish.Cancel') }}</a
                        >
                        <input
                          type="submit"
                          :value="$t('Customer.customerPublish.save')"
                          class="btn btn-primary float-right"
                          @click="saveBlogInfo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="blogIndex.blogPage === 2">
                  <div class="my-profile section-group">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <label for="file-ip-2" class="col-sm-2 col-form-label"
                            > {{ $t('Customer.customerPublish.Blog_flag') }}</label
                          >
                          <div class="group-upload-inputB">
                            <el-upload
                              class="avatar-uploader"
                              :auto-upload="false"
                              action=""
                              :show-file-list="false"
                              :on-change="changeUpload3"
                              ref="blogUploader2"
                            >
                              <avatarVue
                                :src="blogUpdate.userBLog"
                                :size="100"
                              ></avatarVue>
                            </el-upload>
                            <ImgCropperVue
                              ref="cro3"
                              @cropperConfirm="cropperConfirm3"
                              :props_autoCropWidth="100"
                              :props_autoCropHeight="100"
                              :props_full="false"
                              :props_original="true"
                              :props_centerBox="true"
                              :props_high="false"
                              :props_fixed="true"
                              :props_info="true"
                              :props_canMove="true"
                              :props_canScale="true"
                            >
                            </ImgCropperVue>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="username" class="col-sm-2 col-form-label"
                            > {{ $t('Customer.customerPublish.Blog_name') }}</label
                          >
                          <div class="col-sm-10">
                            <input
                              type="text"
                              class="form-control"
                              id="username"
                              :placeholder="$t('Customer.customerPublish.appears')"
                              v-model="blogUpdate.sgL_BlogName"
                            />
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="bio" class="col-sm-2 col-form-label"
                            > {{ $t('Customer.customerPublish.Blog_introduction') }}</label
                          >
                          <div class="col-sm-10">
                            <el-input
                              v-model="blogUpdate.sgL_BlogContent"
                              :placeholder="$t('Customer.customerPublish.Blog_intro')"
                              maxlength="100"
                            ></el-input>
                          </div>
                        </div>

                        <div class="row justify-content-center">
                          <div class="col-8">
                            <a
                              href="javascript:"
                              class="btn btn-secondary"
                              @click="
                                blogIndex.blogPage = 0;
                                resetBlogInfo();
                                GetAllMyLogin();
                              "
                              > {{ $t('Customer.customerPublish.Cancel') }}</a
                            >
                            <input
                              type="submit"
                              :value="$t('Customer.customerPublish.Storage_setting')"
                              class="btn btn-primary float-right"
                              @click="saveUpdateBLogName"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-show="showType === 5">
                      <div class="col-12">
                        <div class="">
                          <div class="card-header">
                            <div class="row">
                              <div class="col-8">
                                <ul
                                  class="nav nav-pills"
                                  v-if="countList != null"
                                >
                                  <li class="nav-item">
                                    <a
                                      class="nav-link"
                                      :class="{ active: isreciver == true }"
                                      href="javascript:void(0);"
                                      @click="showreciverContent('reciver')"
                                      data-toggle="tab"
                                      > {{ $t('Customer.customerPublish.Received_message') }}<span class="count">{{
                                        this.countList.notMsgCount
                                      }}</span></a
                                    >
                                  </li>
                                  <li class="nav-item">
                                    <a
                                      class="nav-link"
                                      :class="{ active: isreciver != true }"
                                      href="javascript:void(0);"
                                      @click="showreciverContent('sent')"
                                      data-toggle="tab"
                                      > {{ $t('Customer.customerPublish.Sent_message') }}<span class="count">{{
                                        this.countList.msgCount
                                      }}</span></a
                                    >
                                  </li>
                                </ul>
                              </div>
                              <!-- Search bar -->
                              <!-- <div class="col-4">
                                <div class="search">
                                  <el-input
                                    placeholder="搜尋"
                                    suffix-icon="fas fa-search"
                                    v-model="title"
                                  ></el-input>
                                </div>
                              </div> -->
                              <!-- /.Search bar -->
                            </div>
                          </div>
                          <!-- /.card-header -->
                          <div class="">
                            <!-- My Profile -->
                            <div class="my-comment section-group">
                              <div class="row">
                                <div class="col-12">
                                  <div class="card">
                                    <div class="card-body p-0">
                                      <el-table :data="reciverModel">
                                        <el-table-column
                                          width="500"
                                          :label="$t('Customer.customerPublish.Message_content')"
                                        >
                                          <template slot-scope="scope">
                                            <a :href="scope.row.clickUrl">{{
                                              scope.row.sgL_Msg_MContent
                                            }}</a>
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="sgL_ImageLogin"
                                          width="38"
                                        >
                                          <template slot-scope="scope">
                                            <avatarVue
                                              :src="scope.row.sgL_ImageLogin"
                                            ></avatarVue>
                                            <!-- <el-avatar
                                  size="small"
                                  :src="scope.row.sgL_ImageLogin"
                                >
                                </el-avatar> -->
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="sgL_Mem_DisplayName"
                                          :label="$t('Customer.customerPublish.user')
                                            "
                                        >
                                        </el-table-column>
                                        <el-table-column
                                          prop="sgL_Msg_MAddTimerI"
                                          :label="$t('Customer.customerPublish.date')"
                                          width="110"
                                        ></el-table-column>
                                        <el-table-column
                                          :label="$t('Customer.customerPublish.Controls')"
                                          width="110"
                                        >
                                          <template slot-scope="scoped">
                                            <a
                                              :href="scoped.row.clickUrl"
                                              :title="$t('Customer.customerPublish.check')"
                                              ><i
                                                class="fa fa-eye fa-fw mx-2"
                                                aria-hidden="true"
                                              ></i
                                            ></a>
                                            <el-button
                                              icon="fa fa-trash-alt fa-fw mx-2"
                                              @click="deleteMsg(scoped.row.id)"
                                              type="danger"
                                              size="mini"
                                              v-show="type != 303"
                                              > {{ $t('Customer.customerPublish.del') }}</el-button
                                            >
                                          </template>
                                        </el-table-column>
                                      </el-table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <!--  引用分页组件 -->
                                  <pagination
                                    v-show="
                                      reciverModel && reciverModel.length > 0
                                    "
                                    :currentPage="pageParamsMessage.currentPage"
                                    :total="pageParamsMessage.total"
                                    :limit="pageParamsMessage.limit"
                                    :small="true"
                                    @handleCurrentChange="handleCurrentMessageChange"
                                    @handleSizeChange="handleSizeMessageChange"
                                  />
                                </div>
                              </div>
                            </div>
                            <!-- /.My Profile -->
                          </div>
                          <!-- /.card-body -->
                        </div>
                      </div>
                    </div>


              <!-- /.card-body -->
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
    </section>
    <div id="groupfriendlist" class="modal fade">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-content-title">
               {{ $t('Customer.customerPublish.Subscribed_subscriber') }}:{{ blogIndex.SubscribeCount }}
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="feedpost-user friendlist_fm">
              <div
                class="friendlist_user"
                v-for="(item, ix) in blogIndex.blogSubList"
              :key="ix">
                <a href="javascript:" class="friendlist_user">
                  <img class="user-logo" :src="item.userLogoBig" />
                  <span class="txt">{{ item.displayName }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
     <medalView ref="medalView" @onMedalSubmit="GetEventMedalsByUser"></medalView>
  </div>
</template>
<script>
import pagination from "../common/Page";
import bases from "../../api/httpApi/base";
import avatarVue from "../common/avatar.vue";
import singleVideoVue from "../Social/singleVideo.vue";
import moreMenuVue from "../Social/moreMenu.vue";
import socialTool from "@/assets/js/socialJs/tool";
import ImgCropperVue from "../common/ImgCropper.vue";
import Editor from "../common/Editor";

import medalView from "../Social/medalView.vue";
export default {
  data() {
    return {
      ReprintedSourceList: [],
      blogIndex: {
        blogPage: 0,
        blogDataList: [],
        pageParams: {
          currentPage: 1,
          limit: 5,
          total: 0,
        },
        blogSubList: [],
        SubscribeCount: 0,
      },
      blogCount: 0,
      blogUpdate: {
        userBLog: "",
        sgL_BlogName: "",
        sgL_BlogContent: "",
      },
      blogInfo: {
        id: 0,
        sgL_UploadTemp: null,
        sgL_NewTypeId: null,
        sgL_Title: "",
        sgL_Content: "",
        sgL_ReprintedId: null,
        sgL_ReprintedStr: "",
        sgL_KeyWord: "",
        sgL_IsShow: true,
        sgL_UploadTempUrl: "",
      },
      blogTypeList: [],
      showType: 1,
      isPicture: true,
      floading: true,
      title: null,
      base: null,
      countList: null,
      customer: null,
      albumList: null,
      videoList: null,
      picList: [],
      dataList: true,
      myPhotoDtl: {
        photoList: null,
        videoList: null,
      },
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pageParamsVideo: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pageParamsPic: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pageParamsMessage: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      isreciver: true,
      reciverModel:null,
      type:303,
      medalListData:[],
      Runningwater:{},
    };
  },
  watch: {
    title(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        if (this.showType === 1) {
          this.getPicturePublish();
        } else if (this.showType === 2) {
          this.getMyVideo();
        } else if (this.showType === 3) {
          this.getMyPicture();
        }else if (this.showType === 5) {
        // this.getReciverMessagecountList();
        this.handleCurrentMessageChange(1);
        this.getReciver();
      }
      }
    },
    /**我的留言 */
    type(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.handleCurrentMessageChange(1);
        this.pageParamsMessage.limit = 12;
        this.pageParamsMessage.total = 0;
        this.getReciver();
      }
    },
    // title(newvalue, oldvalue) {
    //   if (newvalue != oldvalue) {
    //     this.handleCurrentChange(1);
    //     this.getReciver();
    //   }
    // },
  },
  components: {
    pagination,
    avatarVue,
    singleVideoVue,
    moreMenuVue,
    ImgCropperVue,
    Editor,
    medalView,
  },
  created() {
    if (this.$route.query.editBlogId) {
      this.showType = 4;
      this.editBlog(this.$route.query.editBlogId);
    }
    if (this.$route.query.addBlog) {
      this.showType = 4;
      this.blogIndex.blogPage = 1;
    }
    this.$store.dispatch("updateCurrentIndex", 0);
    this.base = bases;
    
    this.customer = this.$store.getters.getcustomer;
        this.GetEventMedalsByUser();
    this.getVideoAndMovieCount();
    this.getPicturePublish();
    this.getCount();
    this.getBlogType();
    this.getReprintedSource();
    this.GetAllMyLogin();
    this.getCustomerModel();
    this.SystemActivityFirst();
  },
  mounted() {
    if (this.$route.query.showBlogSub) {
      this.showType = 4;
      this.lookBlogUser();
    }
  },
  methods: {
        async SystemActivityFirst () {
      const params = {};
      const { data: result } = await this.$api.medalApi.SystemActivityFirst(params);
      if (!result.success) {
        result.error.code !== 500 && this.$message.error(result.error.message);
        return;
      }
      this.Runningwater = result.result ? result.result :{};
    },
    /* 我的留言 */
    getReciverMessagecountList() {
      let params = null;
      this.$api.common.getReciverMessagecountList(params).then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
        }
      });
    },
            async GetEventMedalsByUser () {
      // this.loginUser.userId
      const { data: { result } } = await this.$api.common.GetEventMedalsByUser({ 'usersId': this.loginUser.userId });
      this.medalListData = result;
    },
    async showExchangePoint (Id) {
      this.$refs.medalView.setData(Id);
    },
    deleteMsg(id) {
      let params = {
        Id: id,
      };
      this.$api.common.deleteMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getReciverMessagecountList();
          if (this.isreciver == true) {
            this.type = 303;
          } else {
            this.type = 202;
          }
          this.getReciver();
        }
      });
    },
    getReciver() {
      let params = {
        Type: this.type,
        SGL_Msg_MContent: this.title,
        SkipCount: (this.pageParamsMessage.currentPage - 1) * this.pageParamsMessage.limit, //从第几条开始查，
        MaxResultCount: this.pageParamsMessage.limit, //查多少条
      };
      this.$api.common.reciverMessage(params).then((res) => {
        if (res.data.success) {
          this.reciverModel = res.data.result.items;
          this.pageParamsMessage.total = res.data.result.totalCount;
          if (this.pageParamsMessage.total > 1) {
            this.pageParamsMessage.pageshow = true;
          }
        }
      });
    },
    showreciverContent(type) {
      if (type == "reciver") {
        this.isreciver = true;
        this.type = 303;
      } else {
        this.isreciver = false;
        this.type = 202;
      }
    },
    handleCurrentMessageChange(val){
      this.pageParamsMessage.currentPage = val;
      this.getReciver();
    },
    handleSizeMessageChange(val){
      this.pageParamsMessage.limit = val;
      this.pageParamsMessage.currentPage = 1;
      this.getReciver();
    },

    pushContent() {
      if (this.showType === 4) {
        this.blogIndex.blogPage = 0;
      } else {
        this.$router.push({ name: "customerPublish" });
      }
    },
    pushBlog() {
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      //判断是否已认证
      if (!this.loginUser.sgL_IsCheck) {
        //跳转到认证页面
        this.$router.push({
          name: "certification",
          query: { redirect: "/customerPublish?addBlog=true" },
        });
        return;
      } else {
        this.blogIndex.blogPage = 1;
      }
    },
    lookBlogUser(Id) {
      this.blogIndex.SubscribeCount = 0;
      this.blogIndex.blogSubList = [];
      let params = {
        SkipCount: 0,
        MaxResultCount: 9999, //查多少条
      };
      if (Id) {
        params.Id = Id;
      }
      this.$api.blog.GetMySubscribeList(params).then((res) => {
        this.blogIndex.blogSubList = res.data.result.items;
        this.blogIndex.SubscribeCount = res.data.result.totalCount;
      });
      $("#groupfriendlist").modal("show");
    },
    hideBlog(id) {
      this.$api.blog.UpdateIsShow({ id }).then((res) => {
        this.GetAllMyLogin();
        this.$message.success(this.$t('message.operatesuccessfully'));
      });
    },
    editBlog(id) {
      this.blogInfo.id = id;
      this.blogIndex.blogPage = 1;
      this.getBlogInfo();
    },
    getBlogInfo() {
      this.$api.blog.Get({ id: this.blogInfo.id }).then((res) => {
        this.blogInfo = res.data.result;
      });
    },
    deleteBlog(id) {
      this.$api.blog.Delete({ id }).then((res) => {
        this.$message.success(this.$t('message.operatesuccessfully'));
        this.GetAllMyLogin();
      });
    },
    getCustomerModel() {
      this.$api.common
        .getCustomerModel({ Id: this.loginUser.id })
        .then((res) => {
          this.blogUpdate.userBLog = res.data.result.userBLog;
          this.blogUpdate.sgL_BlogName = res.data.result.sgL_BlogName;
          this.blogUpdate.sgL_BlogContent = res.data.result.sgL_BlogContent;
        });
    },
    saveUpdateBLogName() {
      this.$api.blog.UpdateBLogName(this.blogUpdate).then((res) => {
        this.$message.success(this.$t('message.operatesuccessfully'));
        this.getCustomerModel();
      });
    },
    GetAllMyLogin() {
      let params = {
        sgL_UsersId: this.loginUser.id,
        SkipCount:
          (this.blogIndex.pageParams.currentPage - 1) *
          this.blogIndex.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.blogIndex.pageParams.limit, //查多少条
      };
      this.$api.blog.GetAllMyLogin(params).then((res) => {
        this.blogIndex.blogDataList = res.data.result.items;
        // console.log(11111111111, this.blogIndex.blogDataList);
        this.blogIndex.pageParams.total = res.data.result.totalCount;
      });
    },
    reprinteChange(a) {
      // console.log(11111, a);
    },
    async saveBlogInfo() {
      if (
        !this.blogInfo.sgL_UploadTemp ||
        !this.blogInfo.sgL_NewTypeId ||
        !this.blogInfo.sgL_Title ||
        !this.blogInfo.sgL_Content
      ) {
        this.$message.warning("請輸入必填項");
        return;
      }
      if (this.blogInfo.sgL_Title && this.blogInfo.sgL_Title.length >= 35) {
        this.$message.warning("網誌帖文標題不超過35個字");
      }
      let reqItem = { ...this.blogInfo };
      if (reqItem.sgL_ReprintedId) {
        if (reqItem.sgL_ReprintedId.indexOf("&&&&") !== -1) {
          reqItem.sgL_ReprintedId =
            this.blogInfo.sgL_ReprintedId.split("&&&&")[0];
        } else {
          reqItem.sgL_ReprintedStr = this.blogInfo.sgL_ReprintedId;
          reqItem.sgL_ReprintedId = 0;
        }
      }
      if (this.blogInfo.id) {
        const res = await this.$api.blog.UpdateBlog(reqItem);
        if (res.data.success) {
          this.$message.success(this.$t('message.operatesuccessfully'));
          //this.getBlogInfo();
        } else {
          this.$message.error(res.data.error.message);
        }
      } else {
        const res = await this.$api.blog.CreateBlog(reqItem);
        if (res.data.success) {
          this.$message.success(this.$t('message.operatesuccessfully'));
          //this.getBlogInfo();
        } else {
          this.$message.error(res.data.error.message);
        }
      }
      this.resetBlogInfo();
      this.GetAllMyLogin();
      this.blogIndex.blogPage = 0;
      window.scroll(0, 0);
    },
    getReprintedSource() {
      this.$api.blog
        .getReprintedSource({ SkipCount: 0, MaxResultCount: 99999 })
        .then((res) => {
          this.ReprintedSourceList = res.data.result.items;
        });
    },
    resetBlogInfo() {
      this.blogInfo.id = 0;
      this.blogInfo.sgL_UploadTemp = null;
      this.blogInfo.sgL_NewTypeId = null;
      this.blogInfo.sgL_Title = null;
      this.blogInfo.sgL_Content = null;
      this.blogInfo.sgL_ReprintedId = null;
      this.blogInfo.sgL_ReprintedStr = null;
      this.blogInfo.sgL_KeyWord = null;
      this.blogInfo.sgL_IsShow = true;
      this.blogInfo.sgL_UploadTempUrl = "";
    },
    cropperConfirm2(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      formData.append("Type", "blog");
      this.$api.blog.UploadBlog(formData).then((res) => {
        if (res.data.success) {
          this.blogInfo.sgL_UploadTemp = res.data.result.uploadId;
          this.blogInfo.sgL_UploadTempUrl = res.data.result.url;
        }
      });
      this.$refs.cro2.setDialogVisible(false);
    },
    cropperConfirm3(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      formData.append("Type", "userlogin");
      this.$api.blog.UploadBlog(formData).then((res) => {
        if (res.data.success) {
          this.blogUpdate.userBLog = `${res.data.result.url}?+v=${this.getN()}`;
        }
      });
      this.$refs.cro3.setDialogVisible(false);
    },
    changeUpload2(file, fileList) {
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          this.$refs.avatarUploader.clearFiles();
          return;
      }
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過2M!`);
        return false;
      }
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        that.$refs.cro2.initData(file);
        that.$refs.cro2.setDialogVisible(true);
      };
    },
    changeUpload3(file, fileList) {
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          this.$refs.avatarUploader3.clearFiles();
          return;
      }
      const isLt5M = file.size / 1024 <= 500;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過 500KB!`);
        return false;
      }
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        that.$refs.cro3.initData(file);
        that.$refs.cro3.setDialogVisible(true);
      };
    },
    getBlogType() {
      this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
        this.blogTypeList = res;
      });
    },
    showPic(item) {
      this.$router.push({
        name: "feed",
        query: {
          id: item.id,
        },
      });
    },
     replaceArray (array) {
      let newArray = [];
      for (var i = 0; i < array.length; i++) {
        var s = array[i].replace(/\\/g, "/")
        newArray.push(s)
      }
      return newArray;
    },
    getMyPicture() {
      this.dataList = true;
      let params = {
        SGL_Type: 1,
        IsLogin: true,
        SGL_Content: this.title,
        SkipCount:
          (this.pageParamsPic.currentPage - 1) * this.pageParamsPic.limit,
        MaxResultCount: this.pageParamsPic.limit,
      };
      this.$api.social
        .GetMySocialData(params)
        .then((res) => {
          this.dataList = false;
          if (res.data.success) {
            this.picList = res.data.result.items;
            const that = this;
             this.picList.forEach((element, i) => {
              if (element.sgL_GroupId && element.sgL_GroupImageTemplP && element.sgL_GroupImageTemplS) {
                that.picList[i].sgL_GroupImageTemplP = that.replaceArray(element.sgL_GroupImageTemplP)
                that.picList[i].sgL_GroupImageTemplS = that.replaceArray(element.sgL_GroupImageTemplS)
              }
            });
            this.pageParamsPic.total = res.data.result.totalCount;
            /* this.myPhotoDtl.photoList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
            this.myPhotoDtl.photoCount = this.pageParams.total; */
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch(()=>{ this.dataList = false; });
    },
    getCount() {
      let params = {
        SGL_Type: -1,
        IsLogin: true,
      };
      this.$api.social
        .GetByUserPhotoDtl(params)
        .then((res) => {
          if (res.data.success) {
            this.myPhotoDtl.photoCount = res.data.result.photoCount;
            this.myPhotoDtl.videoCount = res.data.result.moiveCount;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch({});
    },
    likeFunc(item, isadd) {
      socialTool.addfavorite(1, item, !isadd);
    },
    deleteFunc(item) {
      this.$confirm("刪除後無法復原,確認刪除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };
          this.$api.social.DeleteSocialData(params).then((res) => {
            if (res.data.success) {
              this.getMyVideo();
              this.getCount();
            } else {
              this.$message({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    changeShow(item) {
      let params = {
        id: item.id,
        sgL_IsShow: item.sgL_IsShow,
      };
      this.$api.social.UpdateStat(params).then((res) => {
        if (res.data.success) {
          item.sgL_IsShow = !item.sgL_IsShow;
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    copyLink(id) {
      this.copyToClipboard(socialTool.copyLink(id), true);
    },
    getMyVideo() {
       this.dataList = true;
      let params = {
        SGL_Type: 0,
        IsLogin: true,
        SGL_Content: this.title,
        SkipCount:
          (this.pageParamsVideo.currentPage - 1) * this.pageParamsVideo.limit, //从第几条开始查，
        MaxResultCount: this.pageParamsVideo.limit, //查多少条
      };
      this.$api.social
        .GetMySocialData(params)
        .then((res) => {
           this.dataList = false;
          if (res.data.success) {
            this.videoList = res.data.result.items;
            this.pageParamsVideo.total = res.data.result.totalCount;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch(()=>{ this.dataList = false});
    },
    getPicturePublish() {
      this.dataList = true;
      let params = {
        SGL_PG_CName: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.albumApi
        .getPicturePublish(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.albumList = res.data.result.items;
            if (this.albumList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    getVideoAndMovieCount() {
      let params = null;
      this.$api.VideoApi.getVideoAndMovieCount(params).then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
          this.blogCount = res.data.result.bLogCount;
        }
      });
    },
    addfavorite(tid, type, Ftype, longid) {
      let params = {
        sgL_DevicesType: 0,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          if (Ftype == 0) {
            this.getPicturePublish();
          } else if (Ftype == 2) {
            this.getVideoPublish();
          }
        }
      });
    },
    open(id, type) {
      this.$confirm("此操作將永久刪除相簿，是否繼續？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type === "Album") {
            this.delAlbum(id);
          } else {
            this.delvideo(id);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delAlbum(id) {
      let params = {
        Id: id,
      };
      this.$api.albumApi.delAlbuma(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getPicturePublish();
          this.getVideoAndMovieCount();
        }
      });
    },
    delvideo(id) {
      let params = {
        Id: id,
      };
      this.$api.VideoApi.delvideo(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getVideoPublish();
          this.getVideoAndMovieCount();
        }
      });
    },
    getVideoPublish() {
        this.dataList = true;
      let params = {
        Title: this.title,
        SkipCount:
          (this.pageParamsVideo.currentPage - 1) * this.pageParamsVideo.limit, //从第几条开始查，
        MaxResultCount: this.pageParamsVideo.limit, //查多少条
      };
      // return;
      this.$api.VideoApi.getVideoPublish(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.videoList = res.data.result.items;
          if (res.data.result.items <= 0) {
            this.dataList = false;
          }
          this.pageParamsVideo.total = res.data.result.totalCount;
          if (this.pageParamsVideo.total >= 1) {
            this.pageParamsVideo.pageshow = true;
          }
        }
      });
    },
    showContent(type) {
      this.showType = type;
      if (type === 1) {
        this.getPicturePublish();
      } else if (type === 2) {
        this.getMyVideo();
      } else if (type === 3) {
        this.getMyPicture();
      } else if (type === 4) {
        this.GetAllMyLogin();
        this.blogIndex.blogPage = 0;
        this.resetBlogInfo();
        window.scroll(0, 0);
      }else if (type === 5) {
        this.getReciverMessagecountList();
        this.getReciver();
      }
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getPicturePublish();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPicturePublish();
    },
    handleCurrentChangeBlog(val) {
      this.blogIndex.pageParams.currentPage = val;
      this.GetAllMyLogin();
    },
    handleSizeChangeBlog(val) {
      this.blogIndex.pageParams.limit = val;
      this.blogIndex.pageParams.currentPage = 1;
      this.GetAllMyLogin();
    },
    //分页的方法
    handleCurrentChangevideo(val) {
      this.pageParamsVideo.currentPage = val;
      this.getMyVideo();
    },
    handleSizeChangevideo(val) {
      this.pageParamsVideo.limit = val;
      this.pageParamsVideo.currentPage = 1;
      this.getMyVideo();
    },
    //分页的方法
    handleCurrentChangepic(val) {
      this.pageParamsPic.currentPage = val;
      this.getMyPicture();
    },
    handleSizeChangepic(val) {
      this.pageParamsPic.limit = val;
      this.pageParamsPic.currentPage = 1;
      this.getMyPicture();
    },
  },
  computed: {
    customers() {
      return this.$store.getters.getcustomer;
    },
    getPageShow() {
      return this.pageParams.pageshow;
    },
    getPageShowvideo() {
      return this.pageParams.pageshow;
    },
    getalbumList() {
      if (this.albumList == null || this.albumList.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    getvideoList() {
      if (this.videoList == null || this.videoList.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.list_post .list_info {
  overflow: inherit;
}

.group_reply-menus {
  right: 0 !important;
}
.notclick {
  pointer-events: none;
}
.detailTool {
  position: absolute;
  bottom: 6px;
  padding-right: 6px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-content: center;
}
.album-photo-count-loading {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  bottom: 6px;
  height: 20px;
  display: flex;
  align-content: center;
  justify-content: center;
  margin-right: 5px;
  color: white;
  font-size: 0.75rem;
  padding: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerPublish.vue